import React from 'react';

import { Container, WrapperFullHeight } from './styles';
import FooterWrapper from '../../../../components/FooterWrapper';
import { Button } from '../../../../components';
import { Conclusion } from '../../../../components/Icons/Conclusion';
import useOnCloseSchedule from '../../../../hooks/useOnCloseSchedule';
import { ShowAlertByProduct } from './components/ShowAlertByProduct';

type AppointmentConclusionProps = {
  token: string;
  productName: string;
};

export const AppointmentConclusion = ({ token = '', productName = '' }: AppointmentConclusionProps) => {
  const { confirmReset } = useOnCloseSchedule({});

  return (
    <Container>
      <WrapperFullHeight>
        <div className="body-wrapper">
          <Conclusion />
          <h1 className="title">Agendamento realizado com sucesso!</h1>
          <p className="subtitle">As informações do agendamento foram enviadas para o seu e-mail.</p>
          {token.length ? (
            <>
              <p className="subtitle" style={{ marginTop: '20px' }}>
                Para consultar seu agendamento na plataforma use o código abaixo:
              </p>
              <p className="code">{token}</p>
            </>
          ) : null}
          <div style={{ marginTop: 24, paddingLeft: 32, paddingRight: 32 }}>
            <ShowAlertByProduct productName={productName} />
          </div>
        </div>
      </WrapperFullHeight>
      <FooterWrapper>
        <Button title="Voltar para home" onClick={() => confirmReset()} />
      </FooterWrapper>
    </Container>
  );
};
